import { render, staticRenderFns } from "./host-application.vue?vue&type=template&id=19f905d8&scoped=true&"
import script from "./host-application.vue?vue&type=script&lang=js&"
export * from "./host-application.vue?vue&type=script&lang=js&"
import style0 from "./host-application.vue?vue&type=style&index=0&id=19f905d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f905d8",
  null
  
)

export default component.exports